import styled, { keyframes } from 'styled-components';

// Smooth slide up animation for hiding banner
const slideUp = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
    max-height: 200px;
  }
  to {
    opacity: 0;
    transform: translateY(-20px);
    max-height: 0;
  }
`;

// Smooth slide down animation for showing banner
const slideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
    max-height: 0;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    max-height: 200px;
  }
`;

// Main container with gradient background - made thinner
const ReferralBannerContainer = styled.div`
  background: linear-gradient(135deg, #0b0e1a 0%, #6a7f92 100%);
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  margin: 16px;
  box-shadow: 0 8px 32px rgba(11, 14, 26, 0.2);
  min-height: 55px;
  animation: ${(props) => (props.isHiding ? slideUp : slideDown)} 0.3s
    ease-in-out;

  @media (min-width: 1200px) {
    padding: 10px 32px;
    min-height: 50px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 8px 12px;
    gap: 6px;
    min-height: auto;
  }

  @media (max-width: 480px) {
    margin: 8px;
    padding: 6px 10px;
    gap: 4px;
  }
`;

// Text container for better alignment
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    flex: 1;
  }
`;

// First row container for mobile - contains title and button
const FirstRowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  z-index: 2;
  flex: 1;

  @media (max-width: 768px) {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }
`;

// Subtitle container for mobile
const SubtitleContainer = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    width: 100%;
    margin-top: 2px;
  }
`;

// Desktop subtitle container
const DesktopSubtitleContainer = styled.div`
  display: block;

  @media (max-width: 768px) {
    display: none;
  }
`;

// Close button styling - positioned at the very edge
const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(52, 50, 50, 0.59);
  border: none;
  border-radius: 0 12px 0 8px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  font-size: 16px;
  font-weight: bold;
  transition: all 0.2s ease;
  z-index: 3;

  &:hover {
    background: rgba(67, 66, 66, 0.44);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  @media (max-width: 768px) {
    width: 24px;
    height: 24px;
    font-size: 14px;
  }
`;

export default {
  ReferralBannerContainer,
  TextContainer,
  CloseButton,
  FirstRowContainer,
  SubtitleContainer,
  DesktopSubtitleContainer,
};
